export default "__VITE_ASSET__CPLAGaML__"